// extracted by mini-css-extract-plugin
module.exports = {"header":"heading-module--header--31Jz1","title":"heading-module--title--y5Er_","cover":"heading-module--cover--KYWKJ"};